import React from 'react'
import { Check } from "lucide-react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

function FilterSidebar({menuItems, navigate, setStockFilter, stockFilter, filterColors, selectedColors, toggleColor, filterSizes, selectedSizes, toggleSize, selectedPrice, setSelectedPrice, openMain, setOpenMain, openSub, setOpenSub,selectedMainId,setSelectedMainId,slug,priceRange,setPriceRange,visibleColors,setShowAllColors, showAllColors,visibleSizes,setShowAllSizes, showAllSizes,minPrice,maxPrice, closeSidebar}) {
  return (
            <div className="lg:w-72 rounded-lg pt-4 h-fit sticky top-24 shadow-xl">
<div className="flex items-center justify-between border-b-2 pb-2 px-2 sticky top-0 bg-white z-10">
  <h2 className="font-semibold text-xl">
    Apply Filters
  </h2>

  <button
    onClick={closeSidebar}
    className="lg:hidden text-3xl leading-none text-gray-600 hover:text-[#ff0009]"
  >
    &times;
  </button>
</div>
              <div className=" pb-8 custom-scrollbar">
                <div className="mb-4 px-2">
                  <h3 className="font-semibold mb-2 ">Category</h3>
    
                  <div className="w-full gap-3">
                    {menuItems.map((main) => (
                      <div key={main.id} className="">
<div
  className={`flex items-center border-b-2 ${
    selectedMainId === main.id ? "bg-red-50" : ""
  }`}
>
  <input
    type="checkbox"
    checked={selectedMainId === main.id}
    readOnly
    className="ml-2 accent-[#ff0009] w-4 h-4"
    onClick={(e) => {
      e.stopPropagation();
      setSelectedMainId(main.id);
      navigate(`/category/${main.slug}/products`);
    }}
  />

  <button
    type="button"
    className={`flex justify-between items-center w-full px-2 py-2 ${
      selectedMainId === main.id ? "font-semibold" : ""
    }`}
    onClick={() => {
      setOpenMain(openMain === main.id ? null : main.id);
    }}
  >
    <span>{main.name}</span>

    <span className="text-xl font-semibold text-gray-500 leading-none">
      {openMain === main.id ? "-" : "+"}
    </span>
  </button>
</div>
    
                        {openMain === main.id && (
                          <div className="ml-4 mt-2">
                            {main.subcategories.map((sub) => (
                              <div key={sub.id}>
                                <button
                                  className="flex justify-between items-center py-2 w-full border-b-2 cursor-pointer px-1"
                                  onClick={() =>
                                    setOpenSub(openSub === sub.id ? null : sub.id)
                                  }
                                >
                                  <span className="text-base">{sub.name}</span>
                                  <span className="text-xl font-semibold text-gray-500 leading-none ">
                                    {openSub === sub.id ? "-" : "+"}
                                  </span>
                                </button>
    
                                {openSub === sub.id && (
                                  <div className="ml-4 mt-2 cursor-pointer ">
                                    {sub.children.map((child) => (
                                      <label
                                        key={child.id}
                                        className="flex items-center gap-2 border-b-2 py-2 cursor-pointer hover:bg-gray-100"
                                      >
                                        <input
                                          type="checkbox"
                                          checked={child.slug === slug}
                                          onChange={() => navigate(`/child-category/${child.slug}`)}
                                          className="accent-[#ff0009]"
                                        />
    
                                        <span>{child.name}</span>
                                      </label>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mb-6 px-2">
                  <h3 className="font-semibold mb-4 ">
                    Filter by Price
                  </h3>
    
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-gray-700">
                      Price: ₹{priceRange[0]} — ₹{priceRange[1]}
                    </span>
    
                    <button
                      onClick={() => setPriceRange([minPrice, maxPrice])}
                      className="px-4 py-2 bg-gray-100 hover:bg-[#ff0009] hover:text-white transition rounded font-semibold text-sm"
                    >
                      FILTER
                    </button>
                  </div>
    
                <div className="px-2">
    <Slider
      range
      min={minPrice}
      max={maxPrice}
      value={priceRange}
      onChange={setPriceRange}
      trackStyle={[
        {
          backgroundColor: "#FF0009",
          height: 4,
          cursor: "pointer",
        },
      ]}
      railStyle={{
        backgroundColor: "#f3c1c3",
        height: 4,
        cursor: "pointer",
      }}
      handleStyle={[
        {
          borderColor: "#FF0009",
          backgroundColor: "#FF0009",
          width: 18,
          height: 18,
          marginTop: -7,
          cursor: "pointer",
        },
        {
          borderColor: "#FF0009",
          backgroundColor: "#FF0009",
          width: 18,
          height: 18,
          marginTop: -7,
          cursor: "pointer",
        },
      ]}
    />
                  </div>
                </div>
                <div className="mb-8 px-2">
                  <h3 className="font-semibold mb-3 ">Colors</h3>
    
                  <div className="grid grid-cols-1 gap-3">
                    {visibleColors.map((color) => {
                      const selected = selectedColors.includes(color.id);
    
                      return (
                        <button
                          key={color.id}
                          onClick={() => toggleColor(color.id)}
                          className={`flex items-center justify-between w-full `}
                        >
                          <div className="flex items-center gap-2">
        {selected ? (
          <div className="w-6 h-6 rounded-full bg-[#9b1230] flex items-center justify-center">
            <Check size={16} className="text-white stroke-[3]" />
          </div>
        ) : (
          <span
            className="w-6 h-6 rounded-full border border-gray-300"
            style={{
              backgroundColor: color.hexa_code || "#ccc",
            }}
          />
        )}
    
                            <span className="text-sm font-medium text-gray-700">
                              {color.name}
                            </span>
                          </div>
    
                          <span className="text-xs text-gray-500">
                            ({color.count})
                          </span>
                        </button>
                      );
                    })}
                  </div>
    
                  {filterColors.length > 10 && (
                    <button
                      onClick={() => setShowAllColors(!showAllColors)}
                      className="mt-3 text-sm font-medium  hover:underline"
                    >
                      {showAllColors
                        ? "Show Less"
                        : `+${filterColors.length - 10} More`}
                    </button>
                  )}
                </div>
                <div className="mb-8 px-2">
                  <h3 className="font-semibold mb-3 ">Sizes</h3>
    
    <div className="grid grid-cols-1 gap-2">
      {visibleSizes.map((size) => {
        const selected = selectedSizes.includes(size.id);
    
        return (
          <button
            key={size.id}
            onClick={() => toggleSize(size.id)}
            className="flex items-center justify-between w-full py-2"
          >
            <div className="flex items-center gap-3">
              <div
                className={`w-4 h-4 border rounded-sm flex items-center justify-center ${
                  selected
                    ? "bg-[#ff0009] border-[#ff0009]"
                    : "border-gray-300 bg-white"
                }`}
              >
                {selected && (
                  <Check size={12} className="text-white stroke-[3]" />
                )}
              </div>
    
              <span className="text-sm font-medium text-gray-900">
                {size.name}
              </span>
            </div>
    
            <span className="text-sm text-gray-500">
              ({size.count})
            </span>
          </button>
        );
      })}
    </div>
    
                  {filterSizes.length > 10 && (
                    <button
                      onClick={() => setShowAllSizes(!showAllSizes)}
                      className="mt-3 text-sm font-medium  hover:underline"
                    >
                      {showAllSizes
                        ? "Show Less"
                        : `+${filterSizes.length - 10} More`}
                    </button>
                  )}
                </div>
    
              </div>
            </div>
  )
}

export default FilterSidebar

